import { DetailsList, DetailsListLayoutMode, IColumn, SelectionMode } from "@fluentui/react";
import { ReactElement, useMemo } from "react";
import { InfoBlockListProps } from "./InfoBlockList.types";
import React from "react";

function InfoBlockList<TType>({
    columns,
    data,
}: InfoBlockListProps<TType>): ReactElement {
    const detailsListColumns = useMemo(
        () => columns.map<IColumn>((column) => ({
            key: column.key as string,
            name: column.text,
            fieldName: column.key as string,
            minWidth: 150,
            isSortable: false,
            flexGrow: 1,
        })),
        [columns]);

    return (
        <div className="InfoBlockList">
            <DetailsList
                columns={detailsListColumns}
                layoutMode={DetailsListLayoutMode.fixedColumns}
                items={data}
                selectionMode={SelectionMode.none}
            />
        </div>
    );
}

export default InfoBlockList;
